import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054addec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shape-settings" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import ShapeType from './ShapeType.vue';
import ShapeInputs from '@/components/ShapeInputs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShapeSettings',
  setup(__props) {

const store = useStore();
const selectedMenuItem = computed(() => store.getters.selectedMenuItem);
const shape = computed(() => store.getters.shape);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (selectedMenuItem.value === 'shapes')
      ? (_openBlock(), _createBlock(ShapeType, {
          key: 0,
          disabledShapes: ['dxf', 'text', 'rectangle'],
          storeShapeGetter: 'shape',
          storeShapeUpdater: 'updatePlateShape'
        }))
      : _createCommentVNode("", true),
    (shape.value !== '')
      ? (_openBlock(), _createBlock(ShapeInputs, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})